import React, { FC } from 'react';
import { StatsResponse } from '../../models/stats.models';
import { formatSeasonDurationHours } from '../../pages/training-log/training-log.helpers';
import { getElevationMeasurementUnit, getMeasurementUnit } from '../../helpers/general.helpers';

interface StatGridProps {
  stats: StatsResponse | null;
  loading: boolean;
}

const StatGrid: FC<StatGridProps> = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="stat-grid">
        {[0, 1, 2, 3].map((index) => (
          <div className="stat-card stat-card-loading" key={index}>
            <div className="stat-label skeleton-line" />
            <div className="stat-value skeleton-line" />
            <div className="stat-change skeleton-line" />
          </div>
        ))}
      </div>
    );
  }

  const periodCount = stats?.periodBreakdown?.length ?? 0;
  const weekCount = stats?.weekBreakdown?.length ?? 0;
  const distanceUnit = getMeasurementUnit();
  const elevationUnit = getElevationMeasurementUnit();

  return (
    <div className="stat-grid">
      <div className="stat-card">
        <div className="stat-label">Total Duration</div>
        <div className="stat-value">{formatSeasonDurationHours(stats?.totalDuration ?? 0)}</div>
        <div className="stat-change">Season total — {periodCount} periods</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Total Distance</div>
        <div className="stat-value">
          {(stats?.totalDistance ?? 0).toLocaleString()} <span className="stat-unit">{distanceUnit}</span>
        </div>
        <div className="stat-change">All activities combined</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Total Ascent</div>
        <div className="stat-value">
          {(stats?.totalElevationGain ?? 0).toLocaleString()} <span className="stat-unit">{elevationUnit}</span>
        </div>
        <div className="stat-change">Cumulative elevation gain</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Avg Weekly Hours</div>
        <div className="stat-value">{formatSeasonDurationHours(stats?.averageWeeklyDuration ?? 0)}</div>
        <div className="stat-change">Across {weekCount} weeks</div>
      </div>
    </div>
  );
};

export default StatGrid;
